import { ArrowLeft } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { inventoryApi } from "../api";
import { InventoryItemForm } from "../components/InventoryItemForm";
import { InventoryPageHeader } from "../components/InventoryPageHeader";
import { useMutation } from "../hooks";
export default function InventoryItemCreatePage() {
  const navigate = useNavigate();
  const { mutate, loading, error } = useMutation(inventoryApi.createItem);
  return (
    <div className="space-y-5">
      <Link to="/inventory/items" className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-slate-700">
        <ArrowLeft className="h-4 w-4" />
        Back to Items
      </Link>
      <InventoryPageHeader title="Create Inventory Item" />
      {error && <div className="rounded-2xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">{error}</div>}
      <InventoryItemForm submitting={loading} onSubmit={async (payload) => { const saved = await mutate(payload); navigate(`/inventory/items/${saved.id}`); }} />
    </div>
  );
}
